<div class="cv-schema-render-resource-media-control" [ngClass]="{'component-render': isComponentOpen }">
    <div class="report-media-control-form-container layout-v3-4">
        <div class="info-container">
            <div class="info-wrapper">
                <div class="info-parameters">

                    <div *ngIf="resourceMediaModel.captureType === captureType.REPORT">
                        <cv-schema-render-report-image
                                [data]="data"
                                [resourceModel]="resourceModel"
                        ></cv-schema-render-report-image>
                    </div>

                    <div *ngIf="resourceMediaModel.captureType === captureType.SMARTTAG">
                        <cv-schema-render-smart-tag-form
                                [data]="data"
                                [resourceModel]="resourceModel">
                        </cv-schema-render-smart-tag-form>
                    </div>

                    <div class="action-buttons flex-container">
                        <div>
                            <button
								[disabled]="isSavingInProcess"
								class="btn btn-sm cv-btn-light discard" (click)="onCancel()">
                                <span>Discard</span>
                            </button>
                        </div>
                        <div class="btn-save-wrapper">
							<button class="btn btn-sm cv-btn-light" (click)="onSave()"
									[disabled]="isSavingInProcess || !isFormValid()">
								<span>Save</span>
								<div *ngIf="isSavingInProcess" class="loading-wrapper">
									<i class="fas fa-spinner"></i>
								</div>
							</button>
                        </div>
                    </div>
                </div>

                <div class="info-preview" *ngIf="!this.resourceMediaModel.isImageless">
                    <div class="snapshot-image-preview" *ngIf="hasSnapshotPreview()">

						<div *ngIf="manualUploadedImage"
							 (click)="deleteManualUploadedImage()"
							 class="manual-uploaded-image select-action-container">
							<i class="fas fa-trash-alt"></i>
						</div>

                        <img *ngIf="imageUrl"
                            [ngClass]="{
                                'img-responsive': true,
                                'd-none': !imageUrl && !snapshotLoaded
                            }"
                            [src]="imageUrl"
                            (load)="onImageLoad()"
                            (error)="onImageError(imageUrl)">

                        <div class="card skeleton" *ngIf="!snapshotLoaded">
                            <div class="card-body">
                                <div class="card-img card-img-bottom loading">
                                    <div class="loader-icon">
                                        <i class="fas fa-image"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
					<div class="snapshot-image-preview" *ngIf="!hasSnapshotPreview()">
						<cv-drag-and-drop-file
							[acceptFormat]="acceptFormats"
							[message]="'Upload an Image'"
							(filesDropped)="onFilesDropped($event)">
						</cv-drag-and-drop-file>
					</div>
                </div>
            </div>
        </div>
    </div>
</div>
